export default "__VITE_ASSET__K_od9vbE__"